import { render } from "./DivSubsection.vue?vue&type=template&id=2e5e4d98&scoped=true"
import script from "./DivSubsection.vue?vue&type=script&lang=js"
export * from "./DivSubsection.vue?vue&type=script&lang=js"

import "./DivSubsection.vue?vue&type=style&index=0&id=2e5e4d98&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5e4d98"]])

export default __exports__